export default "__VITE_ASSET__KrVRn6pf__"